import prependChild from './prependChild';

// ----------------------------------------------------------------------------

function prependChildAtIndex(parent: Node, element: Node, index: number): void {
    if (index >= parent.childNodes.length) {
        prependChild(parent, element);
    } else {
        parent.insertBefore(element, parent.childNodes[index]);
    }
}

// ----------------------------------------------------------------------------

export default prependChildAtIndex;
